<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            :actions="false"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'emp_att_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Atributo', dataIndex: 'att', sorter: true},
              {title: 'Valor antiguo', dataIndex: 'value_old', sorter: true},
              {title: 'Valor nuevo', dataIndex: 'value_new', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeAttHist.vue